import {
  UPDATE_THEME,
  GET_ALL_STYLES,
  UPDATE_BACKGROUND,
  UPDATE_TEXT_COLOR,
  UPDATE_BUTTON,
  UPDATE_IMAGE_LINK,
  UPDATE_SHOW_FOOTER,
} from './types';

let initialState = {
  style: {
    background_images: [],
    style: {
      footer_current_state: 'footer_disabled',
      background: {
        position_value: 'center',
      },
      text_color: {
        page_text_type: 'color',
        page_text_value: null,
        hover_text_type: 'color',
        hover_text_value: null,
      },
      button: {
        background_type: 'color',
        background_value: null,
        text_type: 'color',
        text_value: null,
        border_type: 'color',
        border_value: null,
        glow_type: 'color',
        glow_value: null,
        border_thickness: 2,
        border_radius: 5,
        hover_type: 'color',
        hover_value: null,
      },
      image_link: {
        border_type: 'color',
        border_value: null,
        border_thickness: 2,
        border_radius: 5,
        similar_to_button: false,
      },
    },
    themes_info: {
      themes: [],
      current_theme_used: '1',
    },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_STYLES:
      return {
        ...state,
        style: action.payload,
      };
    case UPDATE_THEME:
      return {
        ...state,
        style: {
          ...state.style,
          themes_info: {
            ...state.style.themes_info,
            current_theme_used: action.payload,
          },
        },
      };
    case UPDATE_BACKGROUND:
      return {
        ...state,
        style: {
          ...state.style,
          style: {
            ...state.style.style,
            background: action.payload,
          },
        },
      };
    case UPDATE_TEXT_COLOR:
      return {
        ...state,
        style: {
          ...state.style,
          style: {
            ...state.style.style,
            text_color: action.payload,
          },
        },
      };
    case UPDATE_BUTTON:
      return {
        ...state,
        style: {
          ...state.style,
          style: {
            ...state.style.style,
            button: action.payload,
          },
        },
      };
    case UPDATE_IMAGE_LINK:
      return {
        ...state,
        style: {
          ...state.style,
          style: {
            ...state.style.style,
            image_link: action.payload,
          },
        },
      };
    case UPDATE_SHOW_FOOTER:
      return {
        ...state,
        style: {
          ...state.style,
          style: {
            ...state.style.style,
            footer_current_state: `footer_${action.payload}`,
          },
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/styles/reducer.js